import { useTranslation } from 'react-i18next';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import './SelectionLayerDesign.scss';

const SelectionLayerDesign = ({ title, items, actions, actived, onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      className={
        'selection-layer-design flex px-12 py-8 flex-col justify-center items-start gap-8 self-stretch rounded-[4px] ' +
        (actived && 'actived')
      }
      onClick={onClick}
    >
      <span className="text-title-medium">{title}</span>
      {items?.map((item, index) => (
        <div key={index} className="flex items-end gap-8 self-stretch">
          {item?.src ? (
            <img className="w-34 h-34 img-border-rounded" src={item.src} />
          ) : (
            <span className="w-34 h-34">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
                fill="none"
              >
                <rect
                  x="3.65332"
                  y="7.30566"
                  width="5.12932"
                  height="32.8217"
                  transform="rotate(-45.0249 3.65332 7.30566)"
                  fill="#FCE8E4"
                />
                <path
                  d="M34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17ZM4.52391 17C4.52391 23.8904 10.1096 29.4761 17 29.4761C23.8904 29.4761 29.4761 23.8904 29.4761 17C29.4761 10.1096 23.8904 4.52391 17 4.52391C10.1096 4.52391 4.52391 10.1096 4.52391 17Z"
                  fill="#FCE8E4"
                />
              </svg>
            </span>
          )}

          <div className="flex flex-col justify-center grow">
            {item.name && (
              <span
                className="text-label-medium text-truncate"
                style={{ maxWidth: '190px' }}
              >
                {getValueFromString(item.name)}
              </span>
            )}
            {item.material && (
              <span className="text-body-small">{t(item.material)}</span>
            )}
            {item.price && (
              <span className="text-body-small">{item.price}</span>
            )}
          </div>
          {actions?.map(act => {
            return act;
          })}
        </div>
      ))}
    </div>
  );
};

export default SelectionLayerDesign;
